export const addMediaNewestFirst = <T>(existing: T[], added: T[]): T[] => [
  ...added,
  ...existing
];
